import getCoordinatesFromPOIAddress from 'utils/addresses/methods/getCoordinatesFromPOIAddress';

// This is required because the POI service may return postal codes that should have a leading zero
// without the leading zero, and these should be displayed and used with the leading zero.
const isMatchingPostalCode = (postalCode, postalCodeToMatch) => {
  const postalCodeWithoutLeadingZero = postalCodeToMatch.replace(/^0+/, '');
  const matchingCandidates = [postalCodeToMatch, postalCodeWithoutLeadingZero];
  return matchingCandidates.includes(postalCode);
};

const buildAddressLine = (address, postalCodeToUse) => {
  let addressArray = [];
  const basicFields = ['street', 'housenumber', 'neighbourhood'];
  basicFields.forEach((field) => {
    let value = address[field];
    if (value) {
      if (address['street'] && field === 'neighbourhood') {
        addressArray.push(`(${value})`);
      } else {
        addressArray.push(value);
      }
    }
  });

  const addressLine = addressArray.join(' ');

  if (
    address.postalcode &&
    isMatchingPostalCode(address.postalcode, postalCodeToUse)
  ) {
    addressArray.push(postalCodeToUse);
  }

  const areaFields = ['locality', 'localadmin', 'region'];
  areaFields.forEach((field) => {
    let value = address[field];
    if (value && !addressArray.includes(value)) {
      addressArray.push(value);
    }
  });

  const fullAddress = addressArray.join(', ');
  return { addressLine, fullAddress };
};

const getPostalCodeToUseInMapper = (POIPostalCode, userPostalCode) => {
  if (userPostalCode) {
    return userPostalCode;
  }

  if (POIPostalCode) {
    return POIPostalCode;
  }

  return undefined;
};

const mapToAddress = (POIAddressData, idx, postalCodeToUse) => {
  const POIAddress = POIAddressData.properties || {};

  const isVenue = POIAddress.layer === 'venue';

  const { addressLine: address_line, fullAddress } = buildAddressLine(
    POIAddress,
    postalCodeToUse || POIAddress.postalcode
  );
  const company_name = POIAddress.name;
  const zipcode = getPostalCodeToUseInMapper(
    POIAddress.postalcode,
    postalCodeToUse
  );
  const country = POIAddress.country;
  const label = POIAddress.locality;
  const region = POIAddress.region;
  const gid = POIAddress.gid;
  const isComplete = !!POIAddress.street;
  const coordinates = getCoordinatesFromPOIAddress(POIAddressData);

  const address = {
    address_line,
    zipcode,
    country,
    fullAddress,
    label,
    region,
    idx,
    isComplete,
  };

  if (coordinates) {
    address.latitude = coordinates.latitude;
    address.longitude = coordinates.longitude;
  }

  if (isVenue) {
    address.company_name = company_name;
    address.gid = gid;
  }
  return address;
};

const getAddressesFromPOIServiceResponse = (response, postalCodeToUse) => {
  if (!response || !response.features) {
    return;
  }
  const addresses = response.features || [];

  return addresses.map((address, idx) =>
    mapToAddress(address, idx, postalCodeToUse)
  );
};

export default getAddressesFromPOIServiceResponse;
